import { Grid, Stack, TextField, Typography } from "@mui/material"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { BillReceiversType, BillTypeMap } from "../../billReceiversTypes"
import { TranslationKey } from "../../../../../../localization/translations"
import { CVR_LENGTH, EAN_LENGTH, MAX_EMAIL_LENGTH } from "../../../../../../../constants/inputValidationDefaults"

const useStyles = makeStyles()(() => ({
    dialogSubtitle: {
        marginBottom: "1rem",
    },
    input: {
        width: "100%",
    },
}))

const labelType: BillTypeMap<string> = {
    [BillReceiversType.PRIVATE_PERSON]: "Email",
    [BillReceiversType.PUBLIC_INSTITUTION]: "EAN number",
    [BillReceiversType.PRIVATE_COMPANY]: "CVR number",
}

const localizedKey: BillTypeMap<TranslationKey> = {
    [BillReceiversType.PRIVATE_PERSON]: "bill-receivers-input-search-label-email",
    [BillReceiversType.PUBLIC_INSTITUTION]: "bill-receivers-input-search-label-ean-number",
    [BillReceiversType.PRIVATE_COMPANY]: "bill-receivers-input-search-label-number-cvr",
}

const inputMaxLength: BillTypeMap<number> = {
    [BillReceiversType.PRIVATE_PERSON]: MAX_EMAIL_LENGTH,
    [BillReceiversType.PUBLIC_INSTITUTION]: EAN_LENGTH,
    [BillReceiversType.PRIVATE_COMPANY]: CVR_LENGTH,
}

type SearchInvoiceSectionProps = Readonly<{
    search: string
    setSearch: (value: string) => void
    onSearchCall: () => void
    billType: BillReceiversType
    isDisabled: boolean
}>

export function SearchInvoiceSection({
    search,
    setSearch,
    onSearchCall,
    billType,
    isDisabled,
}: SearchInvoiceSectionProps) {
    const { classes } = useStyles()

    return (
        <Grid container direction="column" wrap="nowrap">
            {billType === BillReceiversType.PRIVATE_COMPANY ? (
                <LocalizedStrict id="bill-receivers-company-number">
                    <Typography className={classes.dialogSubtitle} variant="subtitle1" textAlign="start">
                        Enter company number:
                    </Typography>
                </LocalizedStrict>
            ) : (
                <LocalizedStrict id="bill-receivers-send-invoice">
                    <Typography className={classes.dialogSubtitle} variant="subtitle1" textAlign="start">
                        Send invoice to:
                    </Typography>
                </LocalizedStrict>
            )}
            <Stack direction="row" spacing="1rem">
                <LocalizedStrict id={localizedKey[billType]} attrs={{ label: true }}>
                    <TextField
                        className={classes.input}
                        disabled={isDisabled}
                        name="search"
                        value={search}
                        label={labelType[billType]}
                        onChange={(e) => setSearch(e.target.value)}
                        inputProps={{
                            maxLength: inputMaxLength[billType],
                        }}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="bill-receivers-button-continue">
                    <StandardButton
                        disabled={!search.trim() || isDisabled}
                        defaultBorderRadius
                        color="blue"
                        onClick={onSearchCall}
                        fullWidth={false}
                    >
                        Continue
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </Grid>
    )
}
